import React from "react";
import "./quoation.css";

const Quotation = () => {
  return (
    <div className="quotation-container">
      <div className="quotation-column">
       
       <button class="button" onClick={() => window.location.href = 'http://24.232.220.141:5000/'}>VER COTIZACIÓN</button>
      </div>
    </div>
  );
};

export default Quotation;
   // <div className="quotation-container">
    //   <div className="quotation-column">
    //     <p>Voy a comprar</p>
    //     <p>Tengo que pagar</p>
    //   </div>
    //   <div className="quotation-inputs quotation-column">
    //     <input placeholder="Ej: USD$20" />
    //     <input />
    //   </div>
    //   <div className="quotation-column">
    //     <p>Cotización</p>
    //     <h3>$68,00</h3>
    //   </div>
    // </div>